import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { imgsTopicThree } from "../../../assets/activityes/topicthreeActvone";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";


const steps = {
	dialogsevenExtra: 81,
	panelInforActivi: 82,
	dialogseven: 8,
	dialognine: 9,
	selectCategory: 7,
	game: 200,
	gameWon: 1000,
	gamefail: 2000,
	viewActivities: 20,
	viewActivities2: 30,
	panelInstruction1: 31,
	panelInstruction2: 32,
	panelInstruction3: 33,
};

export const SubtopicThreeActivityTwo = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();

	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialogsevenExtra);
	const [countProduct, setCountProduct] = useState(0);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema3], 2);

	useEffect(() => {
		if (loaded) {
			console.log("subtema 3 Activity two");
			ObserverEmitter.emit(EVENTS.subtopicThree.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub03.sub3_act2_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicThree.activityTwo.countProductAct, (value) => {
		setCountProduct(value);
	});

	ObserverEmitter.on(EVENTS.subtopicThree.activityone.finishcoloqued, (points) => {
		if (points >= 7) {
			ObserverEmitter.emit(EVENTS.characterAnimations.festejo);
			setUiToShow(steps.gameWon);
		} else {
			ObserverEmitter.emit(EVENTS.characterAnimations.pena);
			setUiToShow(steps.gamefail);
		}
		//intentos + 1
	});

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![steps.dialogsevenExtra].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicThree.initScene, 2);
						setUiToShow(steps.dialogsevenExtra)
					}} />
				)}
			</>

			{uiToShow === steps.dialogsevenExtra && (
				<>
					<HeaderRedPresentation name="Actividad 2: Evaluación." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Recuerda, puedes utilizar el planograma de manera impresa y obtener la tira con el planograma, o visualizarlo de manera digital a través de la tablet para poder visualizar la información.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelInforActivi);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.hiddenTablet);
						}}
						percentage={"85%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelInforActivi && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Planogramas."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.panelInstruction1);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{/* intrsuciones */}
			{uiToShow === steps.panelInstruction1 && (
				<>
					<PanelInstrucionHands
						text="Toca y arrastra con tu dedo para girar la vista."
						action={() => {
							setUiToShow(steps.panelInstruction2);
						}}
						img={imgInstruction.sub3_act_1_01}
					/>
				</>
			)}
			{uiToShow === steps.panelInstruction2 && (
				<>
					<PanelInstrucionHands
						text="Toca encima de el producto que desees acomodar, después..."
						action={() => {
							setUiToShow(steps.panelInstruction3);
						}}
						img={imgInstruction.sub3_act_1_02}
					/>
				</>
			)}
			{uiToShow === steps.panelInstruction3 && (
				<>
					<PanelInstrucionHands
						text="Toca encima de el lugar en el anaquel donde deseas acomodarla"
						action={() => {
							ObserverEmitter.emit(EVENTS.subtopicThree.activityone.moveFride);
							setUiToShow(steps.game);
						}}
						img={imgInstruction.sub3_act_1_03}
					/>
				</>
			)}

			{uiToShow === steps.game && (
				<>
					<div className="fixed z-30 gradiantBlueClient w-[304px] md:w-[480px] h-full right-0">
						<div className="h-[64px] md:h-[100px] w-full flex items-center px-6">
							<div className="h-[24px] md:h-[60px] w-full bg-red_primary rounded-lg flex justify-center items-center">
								<p className="text-white text-[10px] md:text-[18px] font-semibold">Planograma</p>
							</div>
						</div>
						<div className="h-[calc(100%-64px)] md:h-[calc(100%-100px)] w-full bg-[#F2F2F2] md:bg-transparent relative">
							<div className="h-full w-full pr-3 pt-6 pb-16 md:hidden">
								<div className=" w-full h-full overflow-y-scroll customScrollTicket">
									<img src={imgsTopicThree.planograma} alt="plano" />
								</div>
							</div>
							<div className="h-full w-full  pb-[84px] hidden md:block">
								<div className="h-full w-full">
									<img className="h-full w-full object-contain" src={imgsTopicThree.planograma} alt="planograma" />
								</div>
							</div>
							<div className="absolute bottom-0 h-[60px] md:h-[70px] w-full px-6 md:px-24">
								<div
									onClick={() => {
										ObserverEmitter.emit(EVENTS.subtopicThree.activityTwo.validateResponse);
									}}
									className={`h-[40px] md:h-[45px] w-full ${countProduct === 7 ? "bg-yellow_primary" : "bg-[#9a9a9a]"
										} bg-yellow_primary rounded-xl flex justify-center items-center`}
								>
									<p className="text-white font-bold">Validar respuesta</p>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
			{uiToShow === steps.gameWon && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={35}
						dialogModal="Recuerda observar con cuidado el orden de todos los productos."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 35,
									subtema: tasksId.tema1.activities.subtema3,
								})
							);
							navigator("/tema1/subtema3/activityresult");
						}}
					/>
				</>
			)}
			{uiToShow === steps.gamefail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						dialogModal="Es importante que todo se encuentre en orden."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 5,
									subtema: tasksId.tema1.activities.subtema3,
								})
							);
							navigator("/home1/tema1/subtema3/activityresult");
						}}
					/>
				</>
			)}
		</>
	);
};
